module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Cloudy-b941a8d9ebcd9de59fe572ed03793f85.svg";